import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setLoading } from '../global';
import { bearerAuth } from '../auth';

export interface DemoCredentialListItem {
    id: number;
    tenantKey: string;
    tenantId: string;
    customerId: string;
    templateId: string;
    credentialJson: string;
}

export interface DemoCredentialPage {
    content: DemoCredentialListItem[];
    page: {
        number: number;
        size: number;
        totalPages: number;
        totalElements: number;
        last: boolean;
    };
}

export const deleteDemoCredential = createAsyncThunk<
    void,
    { jwtToken: string | undefined; id: number }
>(
    'DemoCredentialList/delete',
    ({ jwtToken, id }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: { 'Authorization': bearerAuth(jwtToken) },
        };
        return axios
            .delete('/manage/demoCredential/' + id, config)
            .then(() => undefined)
            .finally(() => thunkAPI.dispatch(setLoading(false)));
    },
);

export const getDemoCredentials = createAsyncThunk<
    DemoCredentialPage,
    { jwtToken: string | undefined; query?: string; page?: number; size?: number }
>(
    'DemoCredentialList/getAll',
    ({ jwtToken, query, page, size }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: { 'Authorization': bearerAuth(jwtToken) },
            params: {
                ...(query ? { query } : {}),
                page: page ?? 0,
                size: size ?? 20,
            },
        };
        return axios
            .get('/manage/demoCredential', config)
            .then(response => response.data as DemoCredentialPage)
            .finally(() => thunkAPI.dispatch(setLoading(false)));
    },
);
